export default "__VITE_ASSET__xHM_RTeP__"